import { useDispatch, useSelector } from 'react-redux'
import { setTelefonoPedido } from '../../actions/pedidos'
import i18n from '../../lang/idiomas'

/**
 *
 * @param {Object} props
 * @param {boolean} props.pedidoGuardado
 */
const TelefonoPedido = ({ pedidoGuardado }) => {
  const dispatch = useDispatch()
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const pedido = useSelector(state => state.pedidos.pedido)

  /**
   * Handles the change event for the input field.
   *
   * This function will be called whenever the value of the input changes.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event - The event triggered by the input change.
   */
  function handleChange(event) {
    console.log(event.target.value)
    dispatch(setTelefonoPedido(event.target.value))
  }

  return (
    <form className='form-default'>
      <div className='form-group'>
        <label htmlFor='telefono_pedido'>{i18n.t('domicilios.telenv')}</label>
        <input
          className='form-control'
          type='text'
          maxLength='100'
          pattern='^\d{1,100}$'
          onChange={handleChange}
          name='telefono_pedido'
          id='telefono_pedido'
          value={pedido?.reservado_alfa_1 || ''}
          placeholder={i18n.t('domicilios.telenvmi')}
          disabled={pedidoGuardado || pedido_cargando}
        />
      </div>
    </form>
  )
}

export default TelefonoPedido
